'use strict';

var React = require('react');
var breakpoints = require('../theme/breakpoints.js');

const useMatchDevice = (device) => {
    const mediaQuery = breakpoints.makeMediaQuery(breakpoints.devices[device]);
    const matchMedia = React.useMemo(() => globalThis.matchMedia?.(mediaQuery.replace('@media ', '')), [mediaQuery]);
    const [matches, setMatches] = React.useState(matchMedia?.matches || false);
    React.useEffect(() => {
        const listener = () => setMatches(matchMedia.matches);
        if (matchMedia?.addEventListener) {
            matchMedia?.addEventListener('change', listener);
        }
        else if (matchMedia?.addListener) {
            matchMedia?.addListener(listener);
        }
        return () => {
            if (matchMedia?.removeEventListener) {
                matchMedia?.removeEventListener('change', listener);
            }
            else if (matchMedia?.removeListener) {
                matchMedia?.removeListener(listener);
            }
        };
    }, [matchMedia]);
    return matches;
};

exports.useMatchDevice = useMatchDevice;
//# sourceMappingURL=useMatchDevice.js.map
